import React, { useCallback, useMemo, useState } from "react";

import { FlexComp, FormattedText, ParaTag, SpanTag } from "@tm/static";

import {
  OrderRightCntnt,
  OrderRightStyle,
} from "../../../../components/OrderDetailRightComp/OrderDetailRightComp.style";
import { PricePaymentActionId } from "../../constants";
import type { OrderDetailV2PaymentInfoProps } from "../../types";
import { DownloadInvoiceModal } from "../DownloadInvoice";
import {
  OutlineButton,
  PaymentBreakupTitle,
  PaymentHeader,
} from "./OrderDetailV2PaymentInfo.style";

export const OrderDetailV2PaymentInfo: React.FC<
  OrderDetailV2PaymentInfoProps
> = ({ title, info, bookingId, paymentBreakup, invoiceUrl, actionsList }) => {
  const [isInvoiceModalOpen, setIsInvoiceModalOpen] = useState(false);

  const handleAction = useCallback((actionId: string) => {
    switch (actionId) {
      case PricePaymentActionId.DOWNLOAD_INVOICE:
      case PricePaymentActionId.GET_GST_TAX_INVOICE:
        setIsInvoiceModalOpen(true);
        break;
      default:
        break;
    }
  }, []);

  const visibleActions = useMemo(
    () => actionsList?.filter((a) => a?.isVisible !== false) ?? [],
    [actionsList]
  );

  return (
    <>
      <OrderRightStyle>
        <PaymentHeader>
          {title && (
            <SpanTag fontWeight="bold" fontSize="md">
              <FormattedText value={title} />
            </SpanTag>
          )}
          {info && (
            <SpanTag fontWeight="bold" fontSize="md">
              <FormattedText value={info} />
            </SpanTag>
          )}
        </PaymentHeader>
        <OrderRightCntnt>
          <PaymentBreakupTitle>
            <ParaTag fontWeight="bold" fontSize="xs" margin="0">
              <FormattedText value="Payment Breakup" />
            </ParaTag>
          </PaymentBreakupTitle>
          {paymentBreakup.map((payment, index) => (
            <FlexComp key={index} justifyContent="space-between" margin="8px 0">
              <ParaTag fontSize="xs" margin="0">
                <FormattedText value={payment.sourceText || "-"} />
              </ParaTag>
              <SpanTag fontSize="xs">
                <FormattedText value={payment.value || "-"} />
              </SpanTag>
            </FlexComp>
          ))}
          {visibleActions.map((action) => (
            <OutlineButton
              key={action.actionId}
              disabled={action.isEnabled === false}
              onClick={() => handleAction(action.actionId)}
            >
              {action.label}
            </OutlineButton>
          ))}
        </OrderRightCntnt>
      </OrderRightStyle>

      {!!invoiceUrl && !!bookingId && (
        <DownloadInvoiceModal
          isOpen={isInvoiceModalOpen}
          onClose={() => setIsInvoiceModalOpen(false)}
          invoiceUrl={invoiceUrl}
          bookingId={bookingId}
        />
      )}
    </>
  );
};
